import { ReactComponent as ParkingMeterLogo } from "assets/images/parking-meter-logo.svg";
import ContentContainer from "components/ContentContainer";
import { breakpoints, Heading } from "iparque-components";
import styled, { css } from "styled-components";
import { getAppearFromLeft } from "theme/animations";
import { buildMediaQuery } from "utils/styles";
import { animationMediaQueryConfig } from "../helper";

const animationMediaQuery = buildMediaQuery(animationMediaQueryConfig);

interface AppearFromLeftAnimationProps {
  isOnScreen: boolean;
}

const getAppearFromLeftAnimation = (delay: string) =>
  css<AppearFromLeftAnimationProps>`
    opacity: 0;
    animation: ${({ isOnScreen }) =>
      isOnScreen ? getAppearFromLeft("-20%") : "none"};
    animation-duration: 1s;
    animation-delay: ${delay};
    animation-fill-mode: both;
  `;

export const StyledContentContainer = styled(ContentContainer)`
  z-index: 1;
  position: absolute;
  padding-top: 120px;
  left: 0;
  right: 0;

  #title {
    ${getAppearFromLeftAnimation("0.5s")}
  }

  #text {
    ${getAppearFromLeftAnimation("1s")}
  }

  #list {
    ${getAppearFromLeftAnimation("1.5s")}
  }

  @media ${`not all and ${animationMediaQuery}`} {
    position: initial;
    padding-top: 0;
    padding-bottom: 60px;
  }
`;

export const HeadingContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const Square = styled.div`
  height: 100px;
  width: 65px;
  min-width: 40px;
  margin-right: 45px;
  border: 30px solid ${({ theme }) => theme.colors.street};

  @media ${`not all and ${animationMediaQuery}`} {
    display: none;
  }
`;

export const StyledHeading = styled(Heading)`
  line-height: 1.1;
`;

export const InfoContainer = styled.div`
  margin-top: 60px;

  b {
    display: block;
    margin-top: 60px;
  }

  ul {
    padding-inline-start: 20px;
  }

  @media (max-width: ${breakpoints.md}) {
    margin-top: 30px;

    b {
      margin-top: 30px;
    }

    #list {
      margin-top: 90px;
    }
  }

  @media (min-width: ${breakpoints.md}) {
    max-width: 600px;
  }

  @media (min-width: ${breakpoints.xl}) {
    margin-left: auto;
    transform: translateY(-90px);
  }
`;

export const StyledParkingMeterLogo = styled(
  ParkingMeterLogo
)<AppearFromLeftAnimationProps>`
  ${getAppearFromLeftAnimation("0.2s")}

  width: 75%;
  margin-bottom: 40px;
`;
